/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState } from "react";
import classes from "./orderHistory.module.css";
import Grid from "@mui/material/Grid";
import { withTranslation, Trans } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {
  RefreshIcon,
  DownloadIconNew,
  ViewIconNew,
  EnterArrow,
} from "../../../component/icons/icons";
import pdfIcon from "../../../asset/images/pdf.png";
import jpgIcon from "../../../asset/images/jpg.png";
import pngIcon from "../../../asset/images/png.png";
import placeholderImage from "../../../asset/images/image_placeholder.png";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TableContainer,
  Select,
} from "@mui/material";
import { Collapse } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { DiagramIcon, ProcessOrderIcon } from "../../../component/icons/icons";
import Card from "@mui/material/Card";
import Button from "../../../component/button";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import { FormControl, InputLabel } from "@mui/material";
import Base64ViewerDialog from "../../../component/fileViewer";
import Chip from "@mui/material/Chip";
import Pagination from "@mui/material/Pagination";
import BusApiCall from '../../../helper/axios';
import constants from '../../../helper/constants';
import Loader from '../../../component/loader';
import {formatDate} from "../../../helper/dateFormatter";

const OrderHistory = (props) => {
  const t = props.t;
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPopper, setOpenPopper] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [newVisibility, setNewVisibility] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClick = (event, row) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setOpenPopper(!openPopper);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setOpenPopper(false);
    setAnchorEl(null);
  };

  const confirmVisibilityChange = (item, visibility) => {
    setSelectedRow(item);
    setNewVisibility(visibility);
    setShowConfirmationDialog(true);
    handleClose();
  };

  const handleConfirmationClose = () => {
    setShowConfirmationDialog(false);
    setNewVisibility(null);
  };

  const setImageExtension = (data) => {
    let decoded = atob(decodeURIComponent(data));
    var lowerCase = decoded.toLowerCase();
    var extension = "";
    if (lowerCase.indexOf("png") === 1) {
      extension = "png";
    } else if (
      lowerCase.indexOf("jpg") === 1 ||
      lowerCase.indexOf("jpeg") === 1
    ) {
      extension = "jpg";
    } else if (lowerCase.includes("svg")) {
      extension = "svg+xml";
    } else if (
      lowerCase.indexOf("tif") === 1 ||
      lowerCase.indexOf("tiff") === 1
    ) {
      extension = "tiff";
    } else {
      extension = "png";
    }
    return extension;
  };
  const [selectedFileToView, setSelectedFileToView] = useState(null);
  const [showFileData, setShowFileData] = useState(false);
  const openAttachmentFile = (item) => {
    let search = new URLSearchParams(props.router.location.search);
    let tenantId = search.get("tenantId");
    let data = {};
    if (tenantId && props.providerType === "SOLUTION_PROVIDER") {
      data = {
        tenantId: tenantId,
      };
    }
    setLoading(true);
    BusApiCall("GET", `${constants.busV44UrlPublic}/orders/${props.orderId}/attachments/contents/${item.contentId}`, data)
      .then((res) => {
        const base64 = res?.data?.attachments?.[0]?.attachment ?? res?.data?.base64 ?? res?.data?.attachment ?? "";
        const mimeType = res?.data?.mimeType ?? item?.mimeType ?? "";
        const name = res?.data?.name ?? item?.name ?? "";

        if (!base64) {
          props.setErrorMessage(props.t("PROBLEM_LOADING_FILE"), false);
          setLoading(false);
          return;
        }
        console.log({ "base64": base64, "mimeType": mimeType, "name": name });

        setSelectedFileToView({ base64, mimeType, name });
        setShowFileData(true);
        setLoading(false);
      }).catch((err) => {
        setLoading(false);
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("PROBLEM_LOADING_FILE"), false);
        }
        console.log("err", err);
        setLoading(false);
      })
    // setTimeout(() => {
    //   setShowFileData(true);
    // }, 100);
    // if (item.mimeType === 'application/pdf') {
    //     let pdfWindow = window.open("");
    //     pdfWindow.document.write(
    //         "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
    //         encodeURI(item.attachment) + "'></iframe>"
    //     )
    // } else {
    //     var image = new Image();
    //     image.src = 'data:' + item.mimeType + ';base64,' + item.attachment;
    //     image.style = 'width: 100%';
    //     var w = window.open("");
    //     w.document.write(image.outerHTML);
    // }
  };
  const isElligibleToStartFulfillment = (item) => {
    var currentStatus = item;
    var tenantData = JSON.parse(localStorage.getItem("roles"));
    var securityGroupsList = props.securityGroupsList;
    // This check is to enable actions for ORDER_MANAGER (Ooredoo specific change)
    if (
      currentStatus.assignedPartyRole &&
      currentStatus.assignedPartyRole === "ORDER_MANAGER" &&
      securityGroupsList.includes("ORDER_MANAGER")
    ) {
      item.isEligibleUser = true;
      item.eligibleRole = "";
      return;
    }
    if (securityGroupsList.includes("PARTNER_ADMIN")) {
      return true;
    }
    if (currentStatus.assignedPartyId) {
      if (
        currentStatus.assignedPartyId === tenantData.data.loggedInUser.partyId
      ) {
        return true;
      } else {
        return false;
      }
    }
    if (currentStatus.assignedPartyRole) {
      // var isPartnerTask = currentStatus.assignedPartyRole.includes('PARTNER');
      // if (isPartnerTask && securityGroupsList.includes('PARTNER_ADMIN')) {
      //     return true;
      // } else if (!isPartnerTask && securityGroupsList.includes('ADMIN')) {
      //     return true;
      // } else if (!currentStatus.assignedPartyId && securityGroupsList.includes(currentStatus.assignedPartyRole)) {
      //     return true;
      // }else{
      //     return false;
      // }
      if (securityGroupsList.includes(currentStatus.assignedPartyRole)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };
  const hasActivationParms = (item) => {
    for (var i = 0; i < item.length; i++) {
      if (item[i].namedType === "params" && item[i].namedId !== "[]") {
        return true;
      }
    }
  };
  const isInstanceBilled = (item) => {
    if (props.orderType === 'ChangeSubscription') {
      if (props.packageInstanceBilled) {
        return true;
      } else {
        return false;
      }
    } else {
      if (item.packageInstanceBilled) {
        return true;
      } else {
        return false;
      }
    }
  }
  return (
    <Grid container spacing={1}>
      <Grid
        item
        size={{
          xs: 12,
        }}
      >
        {/* <div className={classes.subTitleDiv, classes.historyWrapper}> */}
        <div>
          {/* <h3>
                        <span>{props.t('ORDER_STATUS_HISTORY')}</span>
                        <Tooltip title={props.t('REFRESH')}>
                            <IconButton onClick={props.getOrderHistory} style={{ float: 'right' }}>
                                <SyncIcon />
                            </IconButton>
                        </Tooltip>
                    </h3> */}
          <h3>
            <span>{props.t("ORDER_STATUS_HISTORY")}</span>
            <Tooltip title={props.t("REFRESH_ORDER_HISTORY")}>
              <IconButton
                className="iconButtonSecondary"
                onClick={props.getOrderHistory}
                style={{ float: "right" }}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
            <span
              onClick={props.getOrderHistory}
              style={{
                fontSize: "14px",
                color: "rgb(245, 131, 32)",
                float: "right",
                paddingTop: 6,
                cursor: "pointer",
                color: props.color,
              }}
            >
              Refresh &nbsp;
            </span>
          </h3>
        </div>
        <Card variant="outlined" className={"roundCorners"}>
          <TableContainer>
            <Table className={"newGlobalTable"}>
              {props.statusHistory && props.statusHistory.length > 0 ? (
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="left" style={{ width: "20%" }}>
                      {props.t("DATE")}
                    </TableCell>
                    <TableCell align="left" style={{ width: "30%" }}>
                      {props.t("STATUS_CHANGE")}
                    </TableCell>
                    <TableCell align="left" style={{ width: "50%" }}>
                      {props.t("ADDITIONAL_INFO")}
                    </TableCell>
                  </TableRow>
                </TableHead>
              ) : (
                <></>
              )}
              <TableBody>
                {props.is_order_status && (
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell style={{ whiteSpace: "nowrap" }}>
                      {/* {props.localizeDateTime(props.order_status_details.statusChangeTime)} */}
                      {/* {convertDate(props.order_status_details.statusChangeTime)} */}
                      {formatDate(props.order_status_details.statusChangeTime)}
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap" }}>
                      <u
                        onClick={() => {
                          props.showActionDialog();
                        }}
                        style={{ cursor: "pointer" }}
                        //  className='activeLink'
                        className="button"
                      >
                        {props.order_status_details.status_text}
                      </u>
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap" }}>
                      {props.order_status_details.status_description &&
                        props.order_status_details.status_description
                          .split("\n")
                          .map((item, index) => (
                            <React.Fragment key={index}>
                              {item}
                              <br />
                            </React.Fragment>
                          ))}
                    </TableCell>
                  </TableRow>
                )}
                {props.statusHistory && props.statusHistory.length > 0 ? (
                  <>
                    {props.statusHistory.map((item, index) => (
                      <React.Fragment key={index}>
                        <TableRow>
                          <TableCell>
                            {item.statusId === "ORD_ITEM_PROCESSING" && (
                              <Tooltip title={props.t("EXPAND")}>
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    props.expandChildProcess(item, index);
                                  }}
                                >
                                  {item.expand ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            {item.humanDate}
                          </TableCell>
                          {/* <TableCell>{item.statusDisplay}</TableCell> */}
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            {index === 0 &&
                              (item.statusDisplay === "Schedule Onboarding" ||
                                item.statusDisplay === "Confirm Installation" ||
                                item.statusDisplay === "Verify Order Payment" ||
                                item.statusDisplay === "Review to be Completed" ||
                                item.statusDisplay ===
                                "Waiting Customer Installation Acceptance" ||
                                item.statusDisplay === "Confirm User Setup" ||
                                item.statusId === "SCHEDULE_ONBOARDING" ||
                                item.statusId === "CONFIRM_INSTALLATION" ||
                                item.statusId === "VERIFY_ODR_PAYMENT" ||
                                item.statusId === "REVIEW_PENDING" ||
                                item.statusId === "USER_SETUP" ||
                                item.statusId === "CUST_COMMITMENT_DATE" ||
                                item.statusId === "CONF_CHANGE_ODR_COMP" ||
                                item.statusId === "CONF_CUST_TRAINING" ||
                                item.statusId === "SDA_ORDER_VALIDATION" ||
                                item.statusId === "CONF_CUST_SUB_CHANGE" ||
                                item.statusId === "CUST_ACCEPT_SIGNOFF" ||
                                item.statusId === "CONF_NOTI_TO_CUST" ||
                                item.statusId === "CONF_SERVS_TERMINATE" ||
                                item.statusId === "PROCESS_SHIFT_ORDER" ||
                                item.statusId === "CONF_SERVICE_SUSPEND" ||
                                item.statusId === "CUST_SERVICE_SUSPEND" ||
                                item.statusId === "CONF_SERVICE_RESUME" ||
                                item.statusId === "CUST_SERVICE_RESUME") &&
                              props.workFlowEnabled &&
                              props.formFields &&
                              props.formFields.fields &&
                              props.formFields.fields.length > 0 ? (
                              <>
                                {item.statusId === "PROCESS_SHIFT_ORDER" ? (
                                  props.providerType !== "SOLUTION_PROVIDER" ||
                                    !props.isEligibleUser ? (
                                    item.statusDisplay
                                  ) : (
                                    <u
                                      onClick={() => {
                                        props.showActionDialog(item.statusId);
                                      }}
                                      style={{ cursor: "pointer" }}
                                      //  className='activeLink'
                                      className="button"
                                    >
                                      {item.statusDisplay}
                                    </u>
                                  )
                                ) : props.isEligibleUser ? (
                                  <u
                                    onClick={() => {
                                      props.showActionDialog(item.statusId);
                                    }}
                                    style={{ cursor: "pointer" }}
                                    //  className='activeLink'
                                    className="button"
                                  >
                                    {item.statusDisplay}
                                  </u>
                                ) : (
                                  item.statusDisplay
                                )}
                              </>
                            ) : (
                              <>
                                {item.statusId === "WAITING_ITEM_PROCESS" &&
                                  props.providerType === "SOLUTION_PROVIDER" ? (
                                  <>
                                    {props.orderStatus !== "Order Fulfilled" &&
                                      isElligibleToStartFulfillment(item) ? (
                                      <u
                                        onClick={() =>
                                          props.togglePrtialProcessingDailog(
                                            false,
                                          )
                                        }
                                        style={{ cursor: "pointer" }}
                                        //  className='activeLink'
                                        className="button"
                                      >
                                        {item.statusDisplay}
                                      </u>
                                    ) : (
                                      item.statusDisplay
                                    )}
                                  </>
                                ) : item.statusId === "START_FULFILLMENT" &&
                                  props.providerType === "SOLUTION_PROVIDER" &&
                                  props.orderStatus !== "Order Fulfilled" &&
                                  isElligibleToStartFulfillment(item) ? (
                                  <u
                                    onClick={() => {
                                      props.editProcessData(item);
                                    }}
                                    style={{ cursor: "pointer" }}
                                    //  className='activeLink'
                                    className="button"
                                  >
                                    {item.statusDisplay}
                                  </u>
                                ) : (
                                  item.statusDisplay
                                )}
                              </>
                            )}
                            {item.processInstanceDiagram &&
                              props.providerType === "SALES_CHNL_PROVIDER" && (
                                <>
                                  <br />
                                  <u
                                    onClick={() => {
                                      props.openHistoryDiagramDialog(item);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {props.t("VIEW_ORDER_INSTANCE_ID")}
                                  </u>
                                  {/* &nbsp; &nbsp;
                                                                <u
                                                                    onClick={() => { props.editProcessData(item) }}
                                                                    style={{ cursor: 'pointer', fontSize: '12px' }}
                                                                >
                                                                    {props.t('VIEW_DETAILS')}
                                                                </u> */}
                                </>
                              )}
                          </TableCell>
                          <TableCell
                            style={{
                              position: "relative",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <label
                              style={{
                                display: "inline-block",
                                paddingRight: "45px",
                              }}
                            >
                              {/* {index === 0 ?
                                                                <>
                                                                    {props.eligibleRole ?
                                                                        <>
                                                                            {props.eligibleRole ? 'Waiting for ' + props.eligibleRole + ' action' : ''}
                                                                        </>
                                                                        :
                                                                        <>
                                                                            {item.doneBy &&
                                                                                item.doneBy.split('\\n').map((item, index) => (
                                                                                    <React.Fragment key={index}>
                                                                                        {item}
                                                                                        <br />
                                                                                    </React.Fragment>
                                                                                ))}
                                                                        </>
                                                                    }
                                                                </>
                                                                :
                                                                <>
                                                                    {item.doneBy &&
                                                                        item.doneBy.split('\\n').map((item, index) => (
                                                                            <React.Fragment key={index}>
                                                                                {item}
                                                                                <br />
                                                                            </React.Fragment>
                                                                        ))}
                                                                </>
                                                            } */}
                              <>
                                {item.doneBy &&
                                  item.doneBy
                                    .split("\\n")
                                    .map((item, index) => (
                                      <React.Fragment key={index}>
                                        {item}
                                        <br />
                                      </React.Fragment>
                                    ))}
                              </>
                            </label>
                          </TableCell>
                        </TableRow>
                        {item.statusId === "ORD_ITEM_PROCESSING" && (
                          <TableRow>
                            <TableCell
                              className="noPaddingClassOnColumn"
                              style={{
                                paddingBottom: 0,
                                paddingTop: 0,
                                border: item.expand ? "" : "none",
                              }}
                              colSpan={4}
                            >
                              <Collapse
                                in={item.expand}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Table className="order_histor_child_table">
                                  <TableBody>
                                    {item.orderItemHistory.map(
                                      (subItem, subIndex) => (
                                        <TableRow key={subIndex}>
                                          <TableCell style={{ width: "10%" }}>
                                            &nbsp;
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              width: "20%",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {formatDate(
                                              subItem.statusChangeTime
                                            )}
                                          </TableCell>
                                          {/* <TableCell>{subItem.statusDisplay}</TableCell> */}
                                          <TableCell style={{ width: "28%" }}>
                                            {subIndex === 0 &&
                                              // (subItem.statusDisplay === 'Schedule Onboarding' || subItem.statusDisplay === 'Confirm Installation' || subItem.statusDisplay === 'Verify Order Payment' || subItem.statusDisplay === 'Review to be Completed' || subItem.statusDisplay === 'Waiting Customer Installation Acceptance' || subItem.statusDisplay === 'Confirm User Setup'
                                              //     || subItem.statusId === 'SCHEDULE_ONBOARDING' || subItem.statusId === 'CONFIRM_INSTALLATION' || subItem.statusId === 'VERIFY_ODR_PAYMENT' || subItem.statusId === 'REVIEW_PENDING' || subItem.statusId === 'USER_SETUP' ||
                                              //     subItem.statusId === 'CUST_COMMITMENT_DATE' || subItem.statusId === 'CONF_CHANGE_ODR_COMP' || subItem.statusId === 'CONF_CUST_TRAINING' || subItem.statusId === 'SDA_ORDER_VALIDATION' || subItem.statusId === 'CONF_CUST_SUB_CHANGE' ||
                                              //     subItem.statusId === 'CUST_ACCEPT_SIGNOFF' || subItem.statusId === 'CONF_NOTI_TO_CUST' || subItem.statusId === 'CONF_SERVS_TERMINATE'
                                              // ) &&
                                              // props.workFlowEnabled && (props.formFields && props.formFields.fields && props.formFields.fields.length > 0) ?
                                              item.isEligibleUser &&
                                              item.taskDetails &&
                                              item.taskDetails.fields &&
                                              item.taskDetails.fields.length >
                                              0 ? (
                                              <>
                                                <u
                                                  onClick={() => {
                                                    props.toggleChildProcessDialog(
                                                      item,
                                                    );
                                                  }}
                                                  style={{ cursor: "pointer" }}
                                                  //  className='activeLink'
                                                  className="button"
                                                >
                                                  {subItem.statusDisplay}
                                                </u>
                                              </>
                                            ) : subItem.statusId ===
                                              "START_FULFILLMENT" &&
                                              props.providerType ===
                                              "SOLUTION_PROVIDER" &&
                                              props.orderStatus !==
                                              "Order Fulfilled" &&
                                              item.orderItemHistory[0]
                                                .statusId !==
                                              "ORDER_ITEM_COMPLETED" &&
                                              isElligibleToStartFulfillment(
                                                subItem,
                                              ) ? (
                                              <>
                                                {isInstanceBilled(item) ?
                                                  <>{subItem.statusDisplay}</>
                                                  :
                                                  <u
                                                    onClick={() => {
                                                      props.editProcessData(item);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                    //  className='activeLink'
                                                    className="button"
                                                  >
                                                    {subItem.statusDisplay}
                                                  </u>
                                                }
                                              </>
                                            ) : (
                                              subItem.statusDisplay
                                            )}
                                          </TableCell>
                                          <TableCell style={{ width: "48%" }}>
                                            {/* {subIndex === 0 ?
                                                                                        <>
                                                                                            {item.eligibleRole ?
                                                                                                <>
                                                                                                    {item.eligibleRole ? 'Waiting for ' + item.eligibleRole + ' action' : ''}
                                                                                                </>
                                                                                                :
                                                                                                <>
                                                                                                    {subItem.doneBy &&
                                                                                                        subItem.doneBy.split('\\n').map((adItem, adIndex) => (
                                                                                                            <React.Fragment key={adItem}>
                                                                                                                {adItem}
                                                                                                                <br />
                                                                                                            </React.Fragment>
                                                                                                        ))}
                                                                                                </>
                                                                                            }
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            {subItem.doneBy &&
                                                                                                subItem.doneBy.split('\\n').map((adItem, adIndex) => (
                                                                                                    <React.Fragment key={adItem}>
                                                                                                        {adItem}
                                                                                                        <br />
                                                                                                    </React.Fragment>
                                                                                                ))}
                                                                                        </>
                                                                                    } */}
                                            <>
                                              {subItem.doneBy &&
                                                subItem.doneBy
                                                  .split("\\n")
                                                  .map((adItem, adIndex) => (
                                                    <React.Fragment
                                                      key={adItem}
                                                    >
                                                      {adItem}
                                                      <br />
                                                    </React.Fragment>
                                                  ))}
                                            </>
                                          </TableCell>
                                        </TableRow>
                                      ),
                                    )}
                                  </TableBody>
                                </Table>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <TableRow>
                    <TableCell>{props.t("NO_DATA_AVAILABLE")}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Grid>
      {props.subscriptionData && props.subscriptionData.length > 0 && (
        <Grid
          item
          size={{
            xs: 12,
          }}
        >
          <div>
            <h3>
              <span>{props.t("SUBSCRIPTIONS")}</span>
            </h3>
          </div>
          <Card variant="outlined" className={"roundCorners"}>
            <TableContainer>
              <Table className={"subscriptionTable"}>
                <TableHead>
                  <TableRow style={{ padding: 0 }}>
                    {/* <TableCell style={{ width: '50px' }}></TableCell> */}
                    <TableCell style={{ width: "30%" }}>
                      {props.t("SUBSCRIPTION_NAME")}
                    </TableCell>
                    <TableCell style={{ width: "50%" }}>
                      {props.t("SUBSCRIPTION_ID")}
                    </TableCell>
                    <TableCell style={{ width: "20%" }}>
                      {props.t("STATUS")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.subscriptionData &&
                    props.subscriptionData.map((item, index) =>
                      item.productId ? (
                        <React.Fragment key={index}>
                          <TableRow className={"newGlobalTable"}>
                            {/* <TableCell>
                              {item.additionalAttributes &&
                                hasActivationParms(
                                  item.additionalAttributes,
                                ) && (
                                  <IconButton
                                    aria-label="expand row"
                                    size="small"
                                    onClick={() =>
                                      props.openSubscription(
                                        item.subscriptionId,
                                      )
                                    }
                                  >
                                    {item.expand ? (
                                      <KeyboardArrowUpIcon />
                                    ) : (
                                      <KeyboardArrowDownIcon />
                                    )}
                                  </IconButton>
                                )}
                            </TableCell> */}
                            <TableCell style={{ display: item.additionalAttributes && hasActivationParms(item.additionalAttributes) ? 'flex' : 'table-cell', alignItems: 'center' }}>
                              {item.additionalAttributes &&
                                hasActivationParms(
                                  item.additionalAttributes,
                                ) && (
                                  <IconButton
                                    aria-label="expand row"
                                    size="small"
                                    onClick={() =>
                                      props.openSubscription(
                                        item.subscriptionId,
                                      )
                                    }
                                  >
                                    {item.expand ? (
                                      <KeyboardArrowUpIcon />
                                    ) : (
                                      <KeyboardArrowDownIcon />
                                    )}
                                  </IconButton>
                                )}
                              {item.productName}
                            </TableCell>
                            <TableCell
                              style={{
                                maxWidth: "auto",
                                whiteSpace: "nowrap",
                              }}
                            // className='wordUnbreak'
                            >
                              {item.subscriptionId}
                            </TableCell>
                            <TableCell>
                              <Chip
                                size="normal"
                                className={
                                  item.status === "Active"
                                    ? "successChip"
                                    : item.status === "Termination in Progress"
                                      ? "errorChip"
                                      : "inProgressChip"
                                }
                                label={item.status}
                              />
                            </TableCell>
                          </TableRow>
                          {/* New collapse row */}
                          <TableRow>
                            <TableCell
                              className={
                                "subscriptionTableCustomeCollapseCell"
                              }
                              colSpan={5}
                              style={{
                                border: "none",
                                borderBottom: item.expand
                                  ? "1px solid rgba(224, 224, 224, 1)"
                                  : "none",
                              }}
                            >
                              <Collapse
                                in={item.expand}
                                timeout="auto"
                                unmountOnExit
                              >
                                <div
                                  style={{
                                    padding: "14px",
                                    paddingLeft: "52px",
                                  }}
                                >
                                  <Grid
                                    container
                                    spacing={2}
                                    alignItems="stretch"
                                  >
                                    <Grid
                                      item
                                      className={"customerInfoTable"}
                                      size={{
                                        xs: 12,
                                        md: 6,
                                      }}
                                    >
                                      <div style={{ position: "relative" }}>
                                        <h3 style={{ marginTop: 0 }}>
                                          <span
                                            style={{ fontSize: "15px" }}
                                          >
                                            {props.t("CONTRACT_DETAILS")}
                                          </span>
                                        </h3>
                                      </div>
                                      <table
                                        className="customerDetailTabel"
                                        id="contractDetails"
                                      >
                                        {item.addiotinalDetails &&
                                          item.addiotinalDetails
                                            .subscriptionId && (
                                            <tbody>
                                              {item.addiotinalDetails
                                                .startDate && (
                                                  <tr>
                                                    <td>{t("START_DATE")}</td>
                                                    <td align="center">:</td>
                                                    <td>
                                                      {formatDate(
                                                        item.addiotinalDetails
                                                          .startDate,
                                                      )}
                                                    </td>
                                                  </tr>
                                                )}
                                              {item.addiotinalDetails
                                                .endDate && (
                                                  <tr>
                                                    <td>{t("END_DATE")}</td>
                                                    <td align="center">:</td>
                                                    <td>
                                                      {formatDate(
                                                        item.addiotinalDetails
                                                          .endDate,
                                                      )}
                                                    </td>
                                                  </tr>
                                                )}
                                              <tr>
                                                <td>
                                                  {t("CONTRACT_PERIOD")}
                                                </td>
                                                <td align="center">:</td>
                                                {item.addiotinalDetails
                                                  .contractPeriod ? (
                                                  <td>
                                                    {
                                                      item.addiotinalDetails
                                                        .contractPeriod
                                                    }
                                                  </td>
                                                ) : (
                                                  <td>
                                                    {t("NO_COMMITMENT")}
                                                  </td>
                                                )}
                                              </tr>
                                              {item.addiotinalDetails
                                                .autoRenewable && (
                                                  <tr>
                                                    <td>
                                                      {t("AUTO_RENEWAL")}
                                                    </td>
                                                    <td align="center">:</td>
                                                    <td>
                                                      {item.addiotinalDetails
                                                        .autoRenewable === "Y"
                                                        ? t("YES")
                                                        : t("NO")}
                                                    </td>
                                                  </tr>
                                                )}
                                            </tbody>
                                          )}
                                      </table>
                                    </Grid>

                                    <Grid
                                      item
                                      className={"customerInfoTable"}
                                      size={{
                                        xs: 12,
                                        md: 6,
                                      }}
                                    >
                                      <div style={{ position: "relative" }}>
                                        <h3 style={{ marginTop: 0 }}>
                                          <span
                                            style={{ fontSize: "15px" }}
                                          >
                                            {props.t("DEVICE_DETAILS")}
                                          </span>
                                        </h3>
                                      </div>
                                      <table
                                        className="customerDetailTabel"
                                        id="deviceDetails"
                                      >
                                        {item.additionalAttributes &&
                                          item.additionalAttributes.map(
                                            (component, c) =>
                                              component.namedType ===
                                              "params" && (
                                                <tbody key={c}>
                                                  {component.namedId &&
                                                    JSON.parse(
                                                      component.namedId,
                                                    ).length > 0 && (
                                                      <>
                                                        {JSON.parse(
                                                          component.namedId,
                                                        ).map(
                                                          (param, p) => (
                                                            <tr key={p}>
                                                              <td>
                                                                {
                                                                  param.label
                                                                }
                                                              </td>
                                                              <td align="center">
                                                                :
                                                              </td>
                                                              <td>
                                                                {
                                                                  param.value
                                                                }
                                                              </td>
                                                            </tr>
                                                          ),
                                                        )}
                                                      </>
                                                    )}
                                                  <tr>
                                                    <td colSpan={3}>
                                                      &nbsp;
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              ),
                                          )}
                                      </table>
                                    </Grid>
                                    <Collapse
                                      in={item.expandHistory}
                                      timeout="auto"
                                      unmountOnExit
                                      style={{ width: "100%" }}
                                    >
                                      <Grid
                                        item
                                        size={{
                                          xs: 12,
                                        }}
                                      >
                                        <Table>
                                          <TableRow>
                                            <TableCell
                                              style={{
                                                borderBottom: "none",
                                              }}
                                            >
                                              {/* <span style={{ display: "flex", alignItems: "center", gap: '1rem', paddingLeft: '40px' }}>
                                                                                                <EnterArrow />
                                                                                                {t('HISTORY')} :
                                                                                            </span> */}
                                              <div
                                                style={{
                                                  position: "relative",
                                                }}
                                              >
                                                <h3
                                                  style={{ marginTop: 0 }}
                                                >
                                                  <span
                                                    style={{
                                                      fontSize: "15px",
                                                    }}
                                                  >
                                                    {props.t("HISTORY")}
                                                  </span>
                                                </h3>
                                              </div>
                                              <div>
                                                <Card
                                                  className="roundCorners"
                                                  variant="outlined"
                                                >
                                                  <TableContainer>
                                                    <Table
                                                      className={
                                                        "subscriptionTable"
                                                      }
                                                    >
                                                      <TableHead>
                                                        <TableRow>
                                                          <TableCell>
                                                            {t("DATE")}
                                                          </TableCell>
                                                          <TableCell>
                                                            {t("STATUS")}
                                                          </TableCell>
                                                        </TableRow>
                                                      </TableHead>
                                                      <TableBody>
                                                        {item.addiotinalDetails &&
                                                          item
                                                            .addiotinalDetails
                                                            .history &&
                                                          item
                                                            .addiotinalDetails
                                                            .history
                                                            .length > 0 &&
                                                          item.addiotinalDetails.history.map(
                                                            (
                                                              historyItem,
                                                              h,
                                                            ) => (
                                                              <TableRow
                                                                key={h}
                                                              >
                                                                <TableCell>
                                                                  {formatDate(
                                                                    historyItem.date,
                                                                  )}
                                                                </TableCell>
                                                                <TableCell>
                                                                  {/* {historyItem.status} */}
                                                                  <Chip
                                                                    size="normal"
                                                                    className={
                                                                      historyItem.status ===
                                                                        "Active"
                                                                        ? "successChip"
                                                                        : historyItem.status ===
                                                                          "Termination in Progress"
                                                                          ? "errorChip"
                                                                          : "inProgressChip"
                                                                    }
                                                                    label={
                                                                      historyItem.status
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              </TableRow>
                                                            ),
                                                          )}
                                                      </TableBody>
                                                    </Table>
                                                  </TableContainer>
                                                </Card>
                                              </div>
                                            </TableCell>
                                          </TableRow>
                                        </Table>
                                      </Grid>
                                    </Collapse>
                                  </Grid>
                                  {false && (
                                    <TableContainer>
                                      <Table>
                                        <TableBody>
                                          {item.addiotinalDetails &&
                                            item.addiotinalDetails
                                              .subscriptionId && (
                                              <>
                                                {item.addiotinalDetails
                                                  .startDate && (
                                                    <TableRow>
                                                      <TableCell>
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "1rem",
                                                            paddingLeft:
                                                              "40px",
                                                          }}
                                                        >
                                                          <EnterArrow />
                                                          {t(
                                                            "START_DATE",
                                                          )} :{" "}
                                                          {formatDate(
                                                            item
                                                              .addiotinalDetails
                                                              .startDate,
                                                          )}
                                                        </span>
                                                      </TableCell>
                                                    </TableRow>
                                                  )}
                                                {item.addiotinalDetails
                                                  .endDate && (
                                                    <TableRow>
                                                      <TableCell>
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "1rem",
                                                            paddingLeft:
                                                              "40px",
                                                          }}
                                                        >
                                                          <EnterArrow />
                                                          {t(
                                                            "END_DATE",
                                                          )} :{" "}
                                                          {formatDate(
                                                            item
                                                              .addiotinalDetails
                                                              .endDate,
                                                          )}
                                                        </span>
                                                      </TableCell>
                                                    </TableRow>
                                                  )}
                                                {item.addiotinalDetails
                                                  .autoRenewable && (
                                                    <TableRow>
                                                      <TableCell>
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "1rem",
                                                            paddingLeft:
                                                              "40px",
                                                          }}
                                                        >
                                                          <EnterArrow />
                                                          {/* {t('RENEWAL_STATUS')} :  */}
                                                          {t("AUTO_RENEWAL")}{" "}
                                                          :{" "}
                                                          {item
                                                            .addiotinalDetails
                                                            .autoRenewable ===
                                                            "Y"
                                                            ? t("YES")
                                                            : t("NO")}
                                                        </span>
                                                      </TableCell>
                                                    </TableRow>
                                                  )}
                                                {item.addiotinalDetails
                                                  .contractPeriod && (
                                                    <TableRow>
                                                      <TableCell>
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "1rem",
                                                            paddingLeft:
                                                              "40px",
                                                          }}
                                                        >
                                                          <EnterArrow />
                                                          {t(
                                                            "CONTRACT_PERIOD",
                                                          )}{" "}
                                                          :{" "}
                                                          {
                                                            item
                                                              .addiotinalDetails
                                                              .contractPeriod
                                                          }{" "}
                                                          {t("MONTHS")}
                                                        </span>
                                                      </TableCell>
                                                    </TableRow>
                                                  )}
                                              </>
                                            )}
                                          {item.additionalAttributes &&
                                            item.additionalAttributes.map(
                                              (component, c) =>
                                                component.namedType ===
                                                "params" && (
                                                  <React.Fragment key={c}>
                                                    {component.namedId &&
                                                      JSON.parse(
                                                        component.namedId,
                                                      ).length > 0 && (
                                                        <>
                                                          {/* <TableRow>
                                                                                            {(c == 0) &&
                                                                                                <>
                                                                                                    {JSON.parse(component.namedId).map((param, p) =>
                                                                                                        <TableCell key={p}><b>{param.label} : {param.value}</b></TableCell>
                                                                                                    )}
                                                                                                </>
                                                                                            }
                                                                                        </TableRow> */}
                                                          <>
                                                            {JSON.parse(
                                                              component.namedId,
                                                            ).map(
                                                              (
                                                                param,
                                                                p,
                                                              ) => (
                                                                <TableRow>
                                                                  <TableCell
                                                                    key={p}
                                                                  >
                                                                    <span
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                        gap: "1rem",
                                                                        paddingLeft:
                                                                          "40px",
                                                                      }}
                                                                    >
                                                                      <EnterArrow />
                                                                      {
                                                                        param.label
                                                                      }{" "}
                                                                      :{" "}
                                                                      {
                                                                        param.value
                                                                      }
                                                                    </span>
                                                                  </TableCell>
                                                                </TableRow>
                                                              ),
                                                            )}
                                                          </>
                                                        </>
                                                      )}
                                                  </React.Fragment>
                                                ),
                                            )}
                                          {item.addiotinalDetails &&
                                            item.addiotinalDetails
                                              .subscriptionId && (
                                              <>
                                                {item.addiotinalDetails
                                                  .history &&
                                                  item.addiotinalDetails
                                                    .history.length > 0 && (
                                                    <TableRow>
                                                      <TableCell>
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "1rem",
                                                            paddingLeft:
                                                              "40px",
                                                          }}
                                                        >
                                                          <EnterArrow />
                                                          {t("HISTORY")} :
                                                        </span>
                                                        <div
                                                          style={{
                                                            paddingLeft: 80,
                                                          }}
                                                        >
                                                          <Card
                                                            className="roundCorners"
                                                            variant="outlined"
                                                          >
                                                            <TableContainer>
                                                              <Table
                                                                className={
                                                                  "subscriptionTable"
                                                                }
                                                              >
                                                                <TableHead>
                                                                  <TableRow>
                                                                    <TableCell>
                                                                      {t(
                                                                        "DATE",
                                                                      )}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                      {t(
                                                                        "STATUS",
                                                                      )}
                                                                    </TableCell>
                                                                  </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                  {item.addiotinalDetails.history.map(
                                                                    (
                                                                      historyItem,
                                                                      h,
                                                                    ) => (
                                                                      <TableRow
                                                                        key={
                                                                          h
                                                                        }
                                                                      >
                                                                        <TableCell>
                                                                          {formatDate(
                                                                            historyItem.date,
                                                                          )}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                          {/* {historyItem.status} */}
                                                                          <Chip
                                                                            size="normal"
                                                                            className={
                                                                              historyItem.status ===
                                                                                "Active"
                                                                                ? "successChip"
                                                                                : historyItem.status ===
                                                                                  "Termination in Progress"
                                                                                  ? "errorChip"
                                                                                  : "inProgressChip"
                                                                            }
                                                                            label={
                                                                              historyItem.status
                                                                            }
                                                                          />
                                                                        </TableCell>
                                                                      </TableRow>
                                                                    ),
                                                                  )}
                                                                </TableBody>
                                                              </Table>
                                                            </TableContainer>
                                                          </Card>
                                                        </div>
                                                      </TableCell>
                                                    </TableRow>
                                                  )}
                                                {item.addiotinalDetails
                                                  .invoices &&
                                                  item.addiotinalDetails
                                                    .invoices.length >
                                                  0 && (
                                                    <TableRow>
                                                      <TableCell>
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "1rem",
                                                            paddingLeft:
                                                              "40px",
                                                          }}
                                                        >
                                                          <EnterArrow />
                                                          {t(
                                                            "INVOICE_HISTORY",
                                                          )}{" "}
                                                          :
                                                        </span>
                                                        <div
                                                          style={{
                                                            paddingLeft: 80,
                                                          }}
                                                        >
                                                          <Card
                                                            className="roundCorners"
                                                            variant="outlined"
                                                          >
                                                            <TableContainer>
                                                              <Table
                                                                className={
                                                                  "subscriptionTable"
                                                                }
                                                              >
                                                                <TableHead>
                                                                  <TableRow>
                                                                    <TableCell>
                                                                      {t(
                                                                        "INVOICE_NO",
                                                                      )}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                      {t(
                                                                        "DATE",
                                                                      )}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                      {t(
                                                                        "STATUS",
                                                                      )}
                                                                    </TableCell>
                                                                  </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                  {item.addiotinalDetails.invoices.map(
                                                                    (
                                                                      invoiceItem,
                                                                      h,
                                                                    ) => (
                                                                      <TableRow
                                                                        key={
                                                                          h
                                                                        }
                                                                      >
                                                                        <TableCell>
                                                                          {
                                                                            invoiceItem.invoiceId
                                                                          }
                                                                        </TableCell>
                                                                        <TableCell>
                                                                          {formatDate(
                                                                            invoiceItem.invoiceDate,
                                                                          )}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                          {/* {invoiceItem.status} */}
                                                                          <Chip
                                                                            size="normal"
                                                                            className={
                                                                              invoiceItem.status ===
                                                                                "Paid"
                                                                                ? "successChip"
                                                                                : "inProgressChip"
                                                                            }
                                                                            label={
                                                                              invoiceItem.status
                                                                            }
                                                                          />
                                                                        </TableCell>
                                                                      </TableRow>
                                                                    ),
                                                                  )}
                                                                </TableBody>
                                                              </Table>
                                                            </TableContainer>
                                                          </Card>
                                                        </div>
                                                      </TableCell>
                                                    </TableRow>
                                                  )}
                                              </>
                                            )}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  )}
                                </div>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ) : null,
                    )}
                </TableBody>
              </Table>
            </TableContainer>
            {props.subsHistoryTotalRecords > 0 && (
              <div
                className="global-custom-pagination"
                style={{ background: "rgba(196, 196, 196, 0.2)" }}
              >
                <label style={{ float: "left", padding: "5px" }}>
                  {props.t("TOTAL_RECORDS")}: {props.subsHistoryTotalRecords}
                </label>
                <label>
                  {/* Rows per page select */}
                  {props.t("ROWS_PER_PAGE")}:
                  <Select
                    value={props.subsHistoryPerPage}
                    onChange={props.updateSubsHistoryPerPageRows}
                  >
                    <MenuItem
                      value={10}
                      classes={{ root: "treeRowPerPageItem" }}
                    >
                      10
                    </MenuItem>
                    <MenuItem
                      value={50}
                      classes={{ root: "treeRowPerPageItem" }}
                    >
                      50
                    </MenuItem>
                    <MenuItem
                      value={100}
                      classes={{ root: "treeRowPerPageItem" }}
                    >
                      100
                    </MenuItem>
                  </Select>
                </label>
                {/* Pagination component */}
                <Pagination
                  page={props.subsHistoryPage}
                  count={Math.ceil(
                    props.subsHistoryTotalRecords / props.subsHistoryPerPage,
                  )}
                  onChange={props.onSubsHistoryPageChange}
                  showFirstButton
                  showLastButton
                />
              </div>
            )}
          </Card>
        </Grid>
      )}
      {/* Old subscription history code */}
      {/* {props.subscriptionChangeHistory.length > 0 &&

                <Grid item xs={12}>
                    <div>
                        <h3><span>{props.t('SUBSCRIPTION_HISTORY')}</span></h3>
                    </div>
                    <Card variant='outlined' className={'roundCorners'}>
                        <TableContainer>
                            <Table className={'newGlobalTable'}>
                                {props.subscriptionChangeHistory.length > 0 ?
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={1} align='left'>{props.t('DATE')}</TableCell>
                                            <TableCell align='left'>{props.t('SOLUTION_PLAN')}</TableCell>
                                            <TableCell align='left'>{props.t('STATUS_CHANGE')}</TableCell>
                                            <TableCell align='left'>{props.t('DEVICE_IDENTIFIER')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    :
                                    <></>
                                }
                                <TableBody>
                                    {props.subscriptionChangeHistory.length > 0 ?
                                        <>
                                            {props.subscriptionChangeHistory.map((item, index) =>
                                                <TableRow key={index}>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>{item.humanDate}</TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>{item.subPlan}</TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>{item.status}</TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>{item.deviceId}</TableCell>
                                                </TableRow>
                                            )
                                            }
                                        </>
                                        :
                                        <TableRow>
                                            <TableCell>{props.t('NO_DATA_AVAILABLE')}</TableCell>
                                        </TableRow>
                                    }
                                </TableBody >
                            </Table >
                        </TableContainer >
                    </Card >
                </Grid >
            } */}
      {props.returnOrders && props.returnOrders.length > 0 && (
        <Grid
          item
          size={{
            xs: 12,
          }}
        >
          {/* <div className={classes.subTitleDiv, classes.historyWrapper}> */}
          <div>
            <h3>
              <span>{props.t("RETURNS")}</span>
            </h3>
          </div>
          <Card variant="outlined" className={"roundCorners"}>
            <TableContainer>
              <Table className={"newGlobalTable"}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">{props.t("RMA_NUMBER")}</TableCell>
                    <TableCell align="left">{props.t("ITEM_QTY")}</TableCell>
                    <TableCell align="left">
                      {props.t("RETURN_STATUS")}
                    </TableCell>
                    <TableCell align="left">{props.t("RETURN_DATE")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.returnOrders.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.returnId}</TableCell>
                      <TableCell>{item.returnQty}</TableCell>
                      <TableCell>{item.statusValue}</TableCell>
                      <TableCell>
                        {formatDate(item.returnDate)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      )}
      {props.providerType === "SALES_CHNL_PROVIDER" &&
        props.tcInformation.tcAction && (
          <>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              {/* <div className={classes.subTitleDiv, classes.historyWrapper}> */}
              <div>
                <h3>
                  <span>{props.t("TERMS_AND_CONDITIONS_INFORMATION")}</span>
                </h3>
              </div>
              <Card variant="outlined" className={"roundCorners"}>
                <TableContainer>
                  <Table className={"newGlobalTable"}>
                    {props.tcInformation.tcAction ? (
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            {props.t("STATUS")}
                          </TableCell>
                          <TableCell align="left">{props.t("DATE")}</TableCell>
                          <TableCell align="left">
                            {props.t("DONE_BY")}
                          </TableCell>
                          <TableCell align="left">
                            {props.t("CLIENT_IP_ADDRESS")}
                          </TableCell>
                          <TableCell align="left">
                            {props.t("T&C_LINKS")}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                    ) : (
                      <></>
                    )}
                    <TableBody>
                      {props.tcInformation.tcAction ? (
                        <>
                          <TableRow>
                            <TableCell>
                              {props.tcInformation.tcAction}
                            </TableCell>
                            <TableCell>
                              {props.tcInformation.humanDate}
                            </TableCell>
                            <TableCell>{props.tcInformation.doneBy}</TableCell>
                            <TableCell>
                              {props.tcInformation.ipAddress}
                            </TableCell>
                            <TableCell>
                              {props.tcLinks && props.tcLinks.length > 0
                                ? props.tcLinks.map((term, index) => (
                                  <label
                                    className={classes.pdfLinks}
                                    key={index}
                                    onClick={() => {
                                      props.downloadPdf(term);
                                    }}
                                  >
                                    {term.termText}
                                  </label>
                                ))
                                : "-"}
                            </TableCell>
                          </TableRow>
                        </>
                      ) : (
                        <TableRow>
                          <TableCell>{props.t("NO_DATA_AVAILABLE")}</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
          </>
        )}
      {!props.priceSummaryView ? (
        <Grid
          item
          size={{
            xs: 12,
          }}
        >
          {/* <div className={classes.subTitleDiv, classes.historyWrapper}> */}
          <div>
            <h3>
              <span>{props.t("NOTES")}</span>
            </h3>
          </div>
          {props.note && props.note.length > 0 ? (
            <Card variant="outlined" className={"roundCorners"}>
              <TableContainer>
                <Table className={"newGlobalTable orderNotesTable"}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">{props.t("NOTE")}</TableCell>
                      <TableCell align="left">{props.t("BY")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.note.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell>{item.text}</TableCell>
                        <TableCell>{item.author}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          ) : (
            <Card variant="outlined" className={"roundCorners"}>
              <TableContainer>
                <Table className={"newGlobalTable"}>
                  <TableBody>
                    <TableRow>
                      <TableCell>{props.t("NO_DATA_AVAILABLE")}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          )}
        </Grid>
      ) : null}
      {
        // props.providerType === 'SALES_CHNL_PROVIDER' &&
        <Grid
          item
          size={{
            xs: 12,
          }}
        >
          {/* <div className={classes.subTitleDiv, classes.historyWrapper}> */}
          <div>
            <h3>
              <span>{props.t("ORDER_ATTACHMENTS")}</span>
              {(props.userPerms.includes("ORDERMGR_UPDATE") ||
                props.userPerms.includes("ORDERMGR_CREATE")) && (
                  <Button
                    className={"buttonSecondary"}
                    onClick={() => props.openUploadAttachmentDialog()}
                    style={{ float: "right" }}
                  >
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {props.t("UPLOAD_NEW_FILE")}
                  </Button>
                )}
            </h3>
          </div>
          {props.attachments && props.attachments.length > 0 ? (
            <Card variant="outlined" className={"roundCorners"}>
              {props.providerType === "SALES_CHNL_PROVIDER" ? (
                <>
                  {/* {props.attachments.map((item, index) =>
                                                <div style={{ width: '100px', marginRight: '8px', marginLeft: '8px', marginBottom: '15px', marginTop: '15px', float: 'left', textAlign: 'center', wordWrap: 'break-word' }} key={index}>
                                                    <img src={item.mimeType === "application/pdf" ? pdfIcon
                                                        : (item.mimeType === "image/jpeg" || item.mimeType === "image/jpg") ? jpgIcon
                                                            : item.mimeType === "image/png" ? pngIcon
                                                                : placeholderImage}
                                                        // style={{ width: '100%', cursor: 'pointer' }}
                                                        style={{ width: '80px', height: '80px', cursor: 'pointer', objectFit: 'contain' }}
                                                        onClick={(e) =>
                                                            props.downloadAttchemnt(item)
                                                        }
                                                    />
                                                    {item.name}
                                                </div>
                                            )} */}
                  <TableContainer>
                    <Table className={"newGlobalTable"} style={{ padding: 0 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>{props.t("FILE_NAME")}</TableCell>
                          <TableCell>{props.t("FILE_TYPE")}</TableCell>
                          <TableCell>{props.t("CREATED_DATE")}</TableCell>
                          <TableCell>{props.t("VISIBILITY")}</TableCell>
                          <TableCell>{props.t("ACTIONS")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {props.attachments && props.attachments.length > 0 ? (
                          props.attachments.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={
                                      item.mimeType === "application/pdf"
                                        ? pdfIcon
                                        : item.mimeType === "image/jpeg" ||
                                          item.mimeType === "image/jpg"
                                          ? jpgIcon
                                          : item.mimeType === "image/png"
                                            ? pngIcon
                                            : placeholderImage
                                    }
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      marginRight: "8px",
                                    }}
                                    alt={item.name}
                                  />
                                  {item.name}
                                </div>
                              </TableCell>
                              <TableCell style={{ textTransform: "uppercase" }}>
                                {item.mimeType === "application/pdf"
                                  ? "PDF"
                                  : item.mimeType.split("/")[1].toUpperCase()}
                              </TableCell>
                              <TableCell>
                                {formatDate(item.createdDate)}
                              </TableCell>
                              <TableCell>
                                {/* {item.isPublic === 'Y' ? props.t('PUBLIC') : props.t('PRIVATE')} */}
                                <FormControl
                                  variant="outlined"
                                  size={"small"}
                                  className={classes.customeSelectLabel}
                                >
                                  <Select
                                    native
                                    value={item.isPublic}
                                    onChange={(e) =>
                                      confirmVisibilityChange(
                                        item,
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="Y">
                                      {props.t("PUBLIC")}
                                    </option>
                                    <option value="N">
                                      {props.t("PRIVATE")}
                                    </option>
                                  </Select>
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Tooltip title={props.t("VIEW")}>
                                    <IconButton
                                      className="buttonSecondary"
                                      onClick={() => openAttachmentFile(item)}
                                    >
                                      <ViewIconNew />
                                    </IconButton>
                                  </Tooltip>
                                  &nbsp;
                                  <Tooltip title={props.t("DOWNLOAD")}>
                                    <IconButton
                                      className="buttonSecondary"
                                      onClick={() =>
                                        props.downloadAttchemnt(item)
                                      }
                                    >
                                      <DownloadIconNew />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={5}>
                              {props.t("NO_DATA_AVAILABLE")}
                            </TableCell>
                          </TableRow>
                        )}
                        <TableRow>
                          <TableCell colSpan={5}>
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                color: "#6b7280",
                                fontSize: ".8rem",
                              }}
                            >
                              <span
                                style={{ marginRight: 8, color: "#909399" }}
                              >
                                <i
                                  className="material-icons"
                                  style={{
                                    fontSize: 20,
                                    verticalAlign: "middle",
                                  }}
                                >
                                  info
                                </i>
                              </span>
                              {props.t("PUBLIC_FILES_VISIBLE_TO_PARTNERS_INFO")}
                            </span>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <>
                  <TableContainer>
                    <Table className={"newGlobalTable"} style={{ padding: 0 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>{props.t("FILE_NAME")}</TableCell>
                          <TableCell>{props.t("FILE_TYPE")}</TableCell>
                          <TableCell>{props.t("CREATED_DATE")}</TableCell>
                          <TableCell>{props.t("ACTIONS")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {props.attachments && props.attachments.length > 0 ? (
                          props.attachments.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={
                                      item.mimeType === "application/pdf"
                                        ? pdfIcon
                                        : item.mimeType === "image/jpeg" ||
                                          item.mimeType === "image/jpg"
                                          ? jpgIcon
                                          : item.mimeType === "image/png"
                                            ? pngIcon
                                            : placeholderImage
                                    }
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      marginRight: "8px",
                                    }}
                                    alt={item.name}
                                  />
                                  {item.name}
                                </div>
                              </TableCell>
                              <TableCell style={{ textTransform: "uppercase" }}>
                                {item.mimeType === "application/pdf"
                                  ? "PDF"
                                  : item.mimeType.split("/")[1].toUpperCase()}
                              </TableCell>
                              <TableCell>
                                {formatDate(item.createdDate)}
                              </TableCell>
                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Tooltip title={props.t("VIEW")}>
                                    <IconButton
                                      className="buttonSecondary"
                                      onClick={() => openAttachmentFile(item)}
                                    >
                                      <ViewIconNew />
                                    </IconButton>
                                  </Tooltip>
                                  &nbsp;
                                  <Tooltip title={props.t("DOWNLOAD")}>
                                    <IconButton
                                      className="buttonSecondary"
                                      onClick={() =>
                                        props.downloadAttchemnt(item)
                                      }
                                    >
                                      <DownloadIconNew />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={5}>
                              {props.t("NO_DATA_AVAILABLE")}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* {props.attachments.map((item, index) =>
                                                item.isPublic === 'Y' &&
                                                <div style={{ width: '100px', marginRight: '8px', marginLeft: '8px', marginBottom: '15px', marginTop: '15px', float: 'left', textAlign: 'center', wordWrap: 'break-word' }} key={index}>
                                                    <img src={item.mimeType === "application/pdf" ? pdfIcon
                                                        : (item.mimeType === "image/jpeg" || item.mimeType === "image/jpg") ? jpgIcon
                                                            : item.mimeType === "image/png" ? pngIcon
                                                                : placeholderImage}
                                                        // style={{ width: '100%', cursor: 'pointer' }}
                                                        style={{ width: '80px', height: '80px', cursor: 'pointer', objectFit: 'contain' }}
                                                        onClick={(e) =>
                                                            props.downloadAttchemnt(item)
                                                        }
                                                    />
                                                    {item.name}
                                                </div>
                                            )} */}
                </>
              )}
            </Card>
          ) : (
            <Card
              variant="outlined"
              className={"roundCorners"}
              style={{ padding: "1.5rem" }}
            >
              <TableContainer>
                <Table className={"newGlobalTable"}>
                  <TableBody>
                    <TableRow>
                      <TableCell>{props.t("NO_DATA_AVAILABLE")}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          )}
          <Dialog
            open={showConfirmationDialog}
            onClose={handleConfirmationClose}
            maxWidth={"sm"}
            fullWidth={true}
            aria-labelledby="confirmation-dialog-visibility"
          >
            <DialogTitle>{props.t("CONFIRM_VISIBILITY_CHANGE")}</DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                <div>
                  {props.t("CONFIRM_VISIBILITY_CHANGE_TEXT", {
                    fileName: selectedRow?.name,
                    visibility:
                      newVisibility === "Y"
                        ? props.t("PUBLIC")
                        : props.t("PRIVATE"),
                  })}
                </div>
                <br />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#6b7280",
                    fontSize: ".8rem",
                  }}
                >
                  <span style={{ marginRight: 8, color: "#909399" }}>
                    <i
                      className="material-icons"
                      style={{ fontSize: 20, verticalAlign: "middle" }}
                    >
                      info
                    </i>
                  </span>
                  {newVisibility === "Y"
                    ? props.t(
                      "CONFIRM_VISIBILITY_CHANGE_TEXT_DESCRIPTION_PUBLIC",
                    )
                    : props.t(
                      "CONFIRM_VISIBILITY_CHANGE_TEXT_DESCRIPTION_PRIVATE",
                    )}
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleConfirmationClose}
                className="buttonSecondary"
              >
                {props.t("CANCEL")}
              </Button>
              <Button
                onClick={() => {
                  props.editVisibility(selectedRow, newVisibility);
                  handleConfirmationClose();
                }}
                color="primary"
              >
                {props.t("CONFIRM")}
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      }
      {showFileData && (
        <Base64ViewerDialog
          base64={selectedFileToView.base64}
          mimeType={selectedFileToView.mimeType}
          title={selectedFileToView.name}
          open={showFileData}
          onClose={() => {
            setShowFileData(false);
            setSelectedFileToView({});
          }}
        />
      )}
      <Loader loading={loading} />
    </Grid>
  );
};

export default withTranslation("translations")(OrderHistory);
